export function convertCamelCaseToText(text) {
  try {
    if (text) {
      return text
        .replace(/([a-z])([A-Z])/g, "$1 $2")
        .split(" ")
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ")
    } else {
      return ""
    }
  } catch (error) {
    console.log(error)
  }
}
